/** What the player reads. Plain words, no codes. The under-age answer deliberately does not say why (neutral age gate). */
const TEXT: Record<string, string> = {
  invalid_username: "Pick a username of 3 to 20 letters, numbers or underscores.",
  invalid_password: "Your password needs 10 to 128 characters.",
  password_too_common: "That password is too easy to guess. Try a few words together.",
  invalid_birth: "Please choose the year and month you were born.",
  cannot_create_account: "We can't create an account for you right now.",
  username_taken: "That username is already taken. Try another.",
  bad_credentials: "That username or password did not match.",
  not_signed_in: "You were signed out. Please sign in again.",
  stale_save: "The saved game changed somewhere else.",
  invalid_save: "The saved game in your account can't be used by this version.",
  busy: "The server is busy. Please try again in a moment.",
  offline: "Can't reach the server. Your game still works, and it will save later.",
  server_error: "Something went wrong. Please try again.",
  invalid_profile: "That choice isn't available.",
  unknown_code: "That code didn't work. Check it and try again.",
  too_many_friends: "The friend list is full.",
  book_private: "This friend hasn't shared their picture book.",
  not_found: "That friend is no longer there.",
  already_linked: "A Google account is already connected.",
  not_needed: "A parent's OK isn't needed for this account.",
  google_unavailable: "Connecting Google isn't available right now. Please try again later.",
  invalid_link: "This link has run out or was already used. Ask for a new one.",
  payments_unavailable: "Buying isn't available right now. Please try again later.",
  purchase_not_allowed: "You can't buy things yet. See what is still needed below.",
  unknown_item: "That item isn't for sale.",
  already_owned: "You already have this item.",
  wrong_mode:"This link does something else. Ask for a new one.",
};

export function accountMessage(code: string, retryAfterSeconds?: number): string {
  if (code === "too_many_attempts") {
    const minutes = Math.max(1, Math.ceil((retryAfterSeconds ?? 900) / 60));
    return `Too many tries. Please wait ${minutes} ${minutes === 1 ? "minute" : "minutes"} and try again.`;
  }
  return TEXT[code] ?? TEXT.server_error!;
}

const LABELS: Record<string, string> = {
  synced: "Saved to your account",
  syncing: "Saving…",
  "not-synced": "Not saved to your account yet",
  conflict: "Two different saves found",
  idle: "",
};

export function syncLabel(status: string): string {
  return LABELS[status] ?? "";
}
